"use client";

import type { AnchorHTMLAttributes, MouseEvent } from "react";
import { logArticleClick } from "./api/click";
import { articleEvent, trackReaderEvent, type ArticlePlacement } from "@/lib/reader-analytics";

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & {
	articleId: string;
	href: string;
	placement?: ArticlePlacement;
};

/** 元記事を別タブで開く共通リンク。左クリック・キーボード・中クリックを各1回計測する。 */
export default function ArticleLink({
	articleId,
	placement = "feed",
	href,
	children,
	...props
}: Props) {
	/** ナビゲーションを止めず、既存ランキングとGA4を更新する。通信エラーは握りつぶす。 */
	function record(event: MouseEvent<HTMLAnchorElement>) {
		if (event.defaultPrevented || (event.type === "auxclick" && event.button !== 1)) return;
		void logArticleClick(articleId);
		const parameters = articleEvent(articleId, href, placement);
		if (parameters) trackReaderEvent("article_open", parameters);
	}
	return (
		<a {...props} href={href} target="_blank" referrerPolicy="origin" rel="noopener" onClick={record} onAuxClick={record}>
			{children}
		</a>
	);
}
